// axios
import axios from 'axios'

const baseURL = ((process.env.NODE_ENV !== 'production') ? `${window.location.origin}/` : '/')
export default axios.create({
  baseURL
  // You can add your headers here
})
